import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Controller } from "react-hook-form";
const inputStyled = {
    "& .ck-editor__editable, & input, & textarea": {
        border: "none",
    },
    "& textarea": {
        pt: 0.5,
    },
};
// le padding du thème est sur la racine, hors de la zone cliquable du Select
const selectStyled = {
    "& .MuiInputLabel-root": {
        pointerEvents: "none",
    },
    "& .MuiInputBase-root": {
        p: 0,
    },
    "& .MuiInputBase-root .MuiSelect-select.MuiInputBase-input": {
        p: "20px 56px 20px 24px",
    },
    "& .MuiSelect-icon": {
        right: 14,
    },
};
const ContactTextField = ({ name, label, control, rules, showError, errors, onResetError, inputAdornmentError, type, multiline, rows, autocomplete, exampleText, }) => {
    const hasError = showError(name);
    const errorMessage = hasError ? errors[name]?.message : undefined;
    const errorId = errorMessage ? `${name}-error` : undefined;
    const exampleId = exampleText ? `${name}-example` : undefined;
    const describedBy = [errorId, exampleId].filter(Boolean).join(" ") || undefined;
    const helperText = errorMessage || exampleText ? (_jsxs(_Fragment, { children: [errorMessage && (_jsx(Box, { component: "span", id: errorId, display: "block", role: "alert", children: errorMessage })), exampleText && (_jsx(Box, { component: "span", id: exampleId, display: "block", sx: { color: "text.secondary", mt: errorMessage ? 0.5 : 0 }, children: exampleText }))] })) : undefined;
    return (_jsx(Controller, { name: name, control: control, rules: rules, render: ({ field }) => (_jsx(TextField, { id: name, ...field, label: label, variant: "filled", error: hasError, helperText: helperText, onChange: (event) => {
                onResetError();
                field.onChange(event);
            }, type: type, multiline: multiline, rows: rows, sx: inputStyled, fullWidth: true, spellCheck: false, slotProps: {
                input: {
                    disableUnderline: true,
                    endAdornment: hasError ? inputAdornmentError : undefined,
                },
                htmlInput: {
                    "aria-required": true,
                    "aria-describedby": describedBy,
                    autoComplete: autocomplete,
                },
                formHelperText: {
                    id: `${name}-helper-text`,
                },
            } })) }));
};
export default ContactTextField;
